import React, { Component } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { TINY_MCE_CONFIG } from '../../../constants/editor';

class TinyMCERichTextEditor extends Component {
    constructor(props) {
        super(props);
        this.editorRef = React.createRef();
    }

    render() {
        return (
            <Editor
                apiKey="w2r4qh2zb6yty7pt6qbf5nqulx9348dibw3n294y6tqb0h87"
                onInit={(_evt, editor) => (this.editorRef.current = editor)}
                value={this.props.value}
                init={TINY_MCE_CONFIG(this.props.onInsertContent)}
                disabled={this.props.disabled}
                onEditorChange={this.props.onChange}
            />
        );
    }
}

export default TinyMCERichTextEditor;
